
































import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

import { BrandRouteResolver } from '@/util/brandRouteResolver'
import { InstanceResolver } from '@/util/instanceResolver'
import { PluginMixin } from '@spa/mixins/plugin'
import { Product } from '@spa/store/modules/orderHistory/types'

@Component
export default class OrderProduct extends Mixins<PluginMixin>(PluginMixin) {
  @Prop({ required: true })
  product: Product

  get itemDetailLink(): string {
    const endpoint = BrandRouteResolver.makeResourceEndpoint({
      brand: this.product.brandEnglishName || '' ,
      path: [
        'item',
        this.product.rootId || '',
      ],
      query: {
        color: this.product.alphabeticColor,
      },
    })

    return endpoint
  }

  formatPrice(price: number): string {
    return price.toLocaleString('ja-JP', { style: 'currency', currency: 'JPY' })
  }

  get shouldShowBrand(): boolean {
    return InstanceResolver.isMulti()
  }
}
